// extracted by mini-css-extract-plugin
export default {"DisneyCosmicToy":"DisneyCosmicToy_DisneyCosmicToy__2Tz7Z","DisneyCosmicToy_hidden":"DisneyCosmicToy_DisneyCosmicToy_hidden__2D5z3"};